<template>
  <div class="view-home">
    <div class="container">
      <div class="quiz-status my-4">
        <div class="card" v-show="countdown">
          <ul>
            <li class="time">
              {{ countdown }}
            </li>
            <li class="recording" v-if="quiz.proctoring">
              {{ $t('testing.recording') }}
            </li>
            <li class="interruption" v-if="quiz.proctoring">
              {{ $t('testing.interruption') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container questions-wrap" v-if="!loading">
      <div class="row mt-3">
        <div class="mobile-mt col-12 order-2 order-2-mob-help order-md-1 col-md-8">
          <div class="question-title mb-3">
            {{ $t('critical-thinking.title') }}
          </div>
          <div v-if="currentQuestion == 1">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-1') }}
              </div>
              <div v-if="this.$i18n.locale == 'ru'">
                Красота – эстетика, изящество,
                <el-input style="width: 250px" placeholder="продолжите ряд"
                          v-model="answersCritical[0].answer"></el-input>

              </div>
              <div v-if="this.$i18n.locale == 'kz'">
                Заманауи – қазіргі, жаңа,
                <el-input style="width: 250px" placeholder="бірқатар жалғастырыңыз"
                          v-model="answersCritical[0].answer"></el-input>

              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 2">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-2') }}
              </div>
              <div>
                3, 6, 18, 75, 4, 8, 24,
                <el-input style="width: 50px" type="number" v-model="answersCritical[1].answer[0]"></el-input>
                5, 10, 30,
                <el-input style="width: 54px" type="number" v-model="answersCritical[1].answer[1]"></el-input>

              </div>
            </div>
          </div>
          <div v-if="currentQuestion == 3">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-3') }}
              </div>
              <div>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item1.png"
                    fit="fill"></el-image>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item2.png"
                    fit="fill"></el-image>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item3.png"
                    fit="fill"></el-image>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item4.png"
                    fit="fill"></el-image>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item5.png"
                    fit="fill"></el-image>
                <el-image
                    style="width: 30%; height: 180px"
                    src="images/tests/urta-item6.png"
                    fit="fill"></el-image>

              </div>
<!--              <el-radio-->
<!--                  v-for="(answer, index) in question_answers3" :key="index" v-model="answersCritical[2].answer"-->
<!--                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>-->
<!--              </el-radio>-->
              <el-radio
                  v-model="answersCritical[2].answer"
                  label="1 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/1urta.PNG"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[2].answer"
                  label="2 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/2urta.PNG"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[2].answer"
                  label="3 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/3urta.PNG"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[2].answer"
                  label="4 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/4urta.PNG"
                  fit="fill"></el-image></span>
              </el-radio>
            </div>
          </div>

          <div v-if="currentQuestion == 4">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-4') }}
              </div>
              <div>
                5 <select v-model="answersCritical[3].answer[0]" class="custom-select-exercises">
                <option value="+">+</option>
                <option value="-">-</option>
                <option value="*">*</option>
                <option value="/">/</option>
              </select>  7 <select v-model="answersCritical[3].answer[1]" class="custom-select-exercises">
                <option value="+">+</option>
                <option value="-">-</option>
                <option value="*">*</option>
                <option value="/">/</option>
              </select>   3  <select v-model="answersCritical[3].answer[2]" class="custom-select-exercises">
                <option value="+">+</option>
                <option value="-">-</option>
                <option value="*">*</option>
                <option value="/">/</option>
              </select>  6 = 53

              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 5">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-5') }}
              </div>
              <div>
                <el-image
                    style="width: 500px; height: 670px"
                    src="images/tests/container_with_water-new.PNG"
                    fit="fill"></el-image>

              </div>
              <el-radio
                  v-for="(answer, index) in question_answers" :key="index" v-model="answersCritical[4].answer"
                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>
              </el-radio>
            </div>
          </div>

          <div v-if="currentQuestion == 6">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-6') }}
              </div>
              <div v-if="this.$i18n.locale == 'ru'">
                Движение – тормоз, стоп,
                <el-input style="width: 250px" placeholder="продолжите ряд"
                          v-model="answersCritical[5].answer"></el-input>
              </div>
              <div v-if="this.$i18n.locale == 'kz'">
                Көріксіз – сұлу, шырайлы,
                <el-input style="width: 250px" placeholder="бірқатар жалғастырыңыз"
                          v-model="answersCritical[5].answer"></el-input>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 7">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-7') }}
              </div>
              <div>
                <el-image
                    style="width: 500px; height: 670px"
                    src="images/tests/saukele.PNG"
                    fit="fill"></el-image>
                <el-image
                    style="width: 670px; height: 510px"
                    src="images/tests/saukele-answers.PNG"
                    fit="fill"></el-image>
              </div>
              <el-radio
                  v-for="(answer, index) in question_answers7" :key="index" v-model="answersCritical[6].answer"
                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>
              </el-radio>
            </div>
          </div>

          <div v-if="currentQuestion == 8">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-8') }}
              </div>
              <div>
                <el-image
                    style="width: 530px; height: 400px"
                    src="images/tests/asyks.png"
                    fit="fill"></el-image>
              </div>
              <el-radio
                  v-for="(answer, index) in question_answers8" :key="index" v-model="answersCritical[7].answer"
                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>
              </el-radio>
            </div>
          </div>

          <div v-if="currentQuestion == 9">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-9') }}
              </div>
              <div v-if="this.$i18n.locale == 'ru'">
                <table border="1">
                  <tbody>
                  <tr v-for="(row, index) in rowsRedundantTable" :key="index" style="width: 100px" class="redundant-word-table">
                    <td class="text-center">{{ row.column1 }}</td>
                    <td><el-input style="width: 250px" placeholder="получившееся слово" v-model="answersCritical[8].words[index]"></el-input></td>
                    <td v-if="index === 0" class="text-center">{{ row.column3 }}</td>
                    <td v-else-if="index === 1" rowspan="3">
                      <el-input style="width: 250px" placeholder="лишнее слово"
                                v-model="answersCritical[8].answer"></el-input>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="this.$i18n.locale == 'kz'">
                <table border="1">
                  <tbody>
                  <tr v-for="(row, index) in rowsRedundantTableKZ" :key="index" style="width: 100px" class="redundant-word-table">
                    <td class="text-center">{{ row.column1 }}</td>
                    <td><el-input style="width: 250px" placeholder="алынған сөз" v-model="answersCritical[8].words[index]"></el-input></td>
                    <td v-if="index === 0" class="text-center">{{ row.column3 }}</td>
                    <td v-else-if="index === 1" rowspan="3">
                      <el-input style="width: 250px" placeholder="қосымша сөз"
                                v-model="answersCritical[8].answer"></el-input>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 10">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-10') }}
              </div>
              <div>
                <el-image
                    style="width: 670px; height: 510px"
                    src="images/tests/red-sands.PNG"
                    fit="fill"></el-image>
              </div>

              <table border="1" class="w-75">
                <tr>
                  <th>
                    <span v-if="this.$i18n.locale == 'ru'">Шаг №</span>
                    <span v-if="this.$i18n.locale == 'kz'">Қадам №</span>
                  </th>
                  <th>
                    <span v-if="this.$i18n.locale == 'ru'">Из сосуда №</span>
                    <span v-if="this.$i18n.locale == 'kz'">№___ыдыстан</span>
                  </th>
                  <th>
                    <span v-if="this.$i18n.locale == 'ru'">В сосуд №</span>
                    <span v-if="this.$i18n.locale == 'kz'">№___ыдысқа</span>
                  </th>
                </tr>
                <tr>
                  <td>1</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[0]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[1]"></el-input></td>
                </tr>
                <tr>
                  <td>2</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[2]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[3]"></el-input></td>
                </tr>
                <tr>
                  <td>3</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[4]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[5]"></el-input></td>
                </tr>
                <tr>
                  <td>4</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[6]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[7]"></el-input></td>
                </tr>
                <tr>
                  <td>5</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[8]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[9]"></el-input></td>
                </tr>
                <tr>
                  <td>6</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[10]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[11]"></el-input></td>
                </tr>
                <tr>
                  <td>7</td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[12]"></el-input></td>
                  <td><el-input type="number" v-model="answersCritical[9].answer[13]"></el-input></td>
                </tr>
                <tr v-if="this.$i18n.locale == 'ru'">
                  <td>Ответ</td>
                  <td colspan="2"><el-input placeholder="Количество шагов" type="number" v-model="answersCritical[9].steps"></el-input></td>
                </tr>
                <tr v-if="this.$i18n.locale == 'kz'">
                  <td>Жауабы</td>
                  <td colspan="2"><el-input placeholder="Қадамдар саны" type="number" v-model="answersCritical[9].steps"></el-input></td>
                </tr>
              </table>

              <div>
<!--                <el-input style="width: 50px" type="number"-->
<!--                          v-model="answersCritical[9].answer"></el-input>-->
<!--                <span v-if="this.$i18n.locale == 'ru'"> шага (-ов)</span>-->
<!--                <span v-if="this.$i18n.locale == 'kz'"> қадам</span>-->
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 11">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-11') }}
              </div>
              <div class="crossword">
                <div v-for="(row, rowIndex) in answersCritical[10].answer" :key="rowIndex" class="crossword-row">
                  <div v-for="(cell, colIndex) in row" :key="colIndex" :class="['crossword-cell', { 'black-cell': cell.black }]">
                    <template v-if="!cell.black">
                      <input v-model="cell.value" type="number" :placeholder="cell.placeholder" :disabled="cell.disabled" />
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 12">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-12') }}
              </div>
              <div v-if="this.$i18n.locale == 'ru'">
                <table border="1">
                  <tbody>
                  <tr v-for="(row, index) in rowsRedundantTable12" :key="index" style="width: 100px" class="redundant-word-table">
                    <td  class="text-center">{{ row.column1 }}</td>
                    <td v-if="index === 0" class="text-center">{{ row.column2 }}</td>
                    <td v-else-if="index === 1" rowspan="5">
                      <el-input style="width: 250px" placeholder="Общее слово" maxlength="3"
                                v-model="answersCritical[11].answer"></el-input>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="this.$i18n.locale == 'kz'">
                <table border="1">
                  <tbody>
                  <tr v-for="(row, index) in rowsRedundantTable12KZ" :key="index" style="width: 100px" class="redundant-word-table">
                    <td  class="text-center">{{ row.column1 }}</td>
                    <td v-if="index === 0" class="text-center">{{ row.column2 }}</td>
                    <td v-else-if="index === 1" rowspan="5">
                      <el-input style="width: 250px" placeholder="Жалпы сөз" maxlength="3"
                                v-model="answersCritical[11].answer"></el-input>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 13">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-13') }}
              </div>
              <div class="row align-items-center">
                <el-image
                    style="width: 400px; height: 400px"
                    src="images/tests/question13.png"
                    fit="fill"></el-image>
                <div>
                  <div>3288=4</div>
                  <div>9124=1</div>
                  <div>3741=0</div>
                  <div>6854=<el-input style="width: 50px" placeholder="???" type="number"
                                      v-model="answersCritical[12].answer"></el-input></div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 14">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-14') }}
              </div>
              <div class="row align-items-center">
                <el-image
                    style="width: 400px; height: 400px"
                    src="images/tests/cube.png"
                    fit="fill"></el-image>
              </div>
<!--              <el-radio-->
<!--                  v-for="(answer, index) in question_answers14" :key="index" v-model="answersCritical[13].answer"-->
<!--                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>-->
<!--              </el-radio>-->

              <el-radio
                  v-model="answersCritical[13].answer"
                  label="1 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/cube-1.jpg"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[13].answer"
                  label="2 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/cube-2.jpg"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[13].answer"
                  label="3 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/cube-3.jpg"
                  fit="fill"></el-image></span>
              </el-radio>
              <el-radio
                  v-model="answersCritical[13].answer"
                  label="4 вид" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item"><el-image
                  style="width: 230px; height: 200px"
                  src="images/tests/cube-4.jpg"
                  fit="fill"></el-image></span>
              </el-radio>
            </div>
          </div>

          <div v-if="currentQuestion == 15">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-15') }}
              </div>
              <div class="row align-items-center" v-if="this.$i18n.locale == 'ru'">
                <el-image
                    style="width: 520px; height: 500px"
                    src="images/tests/flower-15ru.png"
                    fit="fill"></el-image>
                <el-input class="flower_letter" style="top: 345px;left: 76px" placeholder="?" v-model="answersCritical[14].answer[0]"></el-input>
                <el-input class="flower_word" style="top: 345px;left: 200px;" placeholder="?" v-model="answersCritical[14].answer[1]"></el-input>
              </div>

              <div class="row align-items-center" v-if="this.$i18n.locale == 'kz'">
                <el-image style="width: 520px; height: 500px"
                          src="images/tests/flower-15kz.png"
                          fit="fill"></el-image>
                <el-input class="flower_letter" style="top: 533px; left: 246px;" placeholder="?" v-model="answersCritical[14].answer[0]"></el-input>
                <el-input class="flower_word" style="top: 345px;left: 200px;" placeholder="?" v-model="answersCritical[14].answer[1]"></el-input>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 16">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-16') }}
              </div>
              <div style="position: relative">
<!--                <img src="/images/safe.png">-->
                <el-image
                    style="width: 670px; height: 500px"
                    src="images/tests/safe.png"
                    fit="fill"></el-image>
                <div class="crossword-safe">
                  <div v-for="(row, rowIndex) in answersCritical[15].answer" :key="rowIndex" class="crossword-row">
                    <div v-for="(cell, colIndex) in row" :key="colIndex" :class="['crossword-cell-safe', { 'black-cell': cell.black }, {'answer-cell' : !cell.black && !cell.disabled}]">
                      <template v-if="!cell.black">
                        <input v-model="cell.value" :maxlength="2" type="number" :placeholder="cell.placeholder" :disabled="cell.disabled" />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 17">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-17') }}
              </div>
              <div>
                <el-input :placeholder="$t('write-words')" v-model="answersCritical[16].answer"></el-input>
              </div>
            </div>
          </div>

          <div v-if="currentQuestion == 18">
            <div class="question-title mb-3">
              {{ $t('critical-thinking.question') }} №{{orderQuestionsCT.indexOf(currentQuestion) + 1}}
            </div>
            <div class="question-content ck-content">
              <div class="question-content-title">
                {{ $t('critical-thinking.question-18') }}
              </div>
              <el-image
                  style="width: 600px; height: 460px"
                  src="images/tests/valves_new.PNG"
                  fit="fill"></el-image>
              <el-radio
                  v-for="(answer, index) in question_answers18" :key="index" v-model="answersCritical[17].answer"
                  :label="answer" border class="col-12 col-md-auto mx-0 single-one"><span class="answer-item">{{answer}}</span>
              </el-radio>
            </div>
          </div>

        </div>

        <div style="display: flex;flex-direction: column" class="col-12 col-md-4 order-1 pc-buttons">
          <div class="navigation">
            <div class="card">
              <h3>{{ $t('testing.navigation') }}</h3>

              <div class="navigation-wrap clearfix">
<!--                <a :disabled="blockButton" @click="goTo(key)" class="cursor-pointer"-->
<!--                   v-for="(key) in questions.length" :key="`question_${key}`"-->
<!--                   :class="{'checked': saved_answers[key]!=null , 'active': ($route.params.id === key.toString()) }">{{-->
<!--                    key-->
<!--                  }}</a>-->
                <a :disabled="blockButton" @click="goTo(orderQuestionsCT[key])" class="cursor-pointer"
                   v-for="(item, key) in this.orderQuestionsCT" :key="`question_${orderQuestionsCT[key]}`"
                   :class="{'active': (currentQuestion === orderQuestionsCT[key]), 'checked' : isChecked(orderQuestionsCT[key]) }"
                >
                  {{key + 1}}
                </a>
              </div>
              <div style="margin: 1rem 0">
                <div class="mx-auto" style="display: flex;justify-content: space-between">
                  <a style="min-width: 130px;" class="btn btn-default" @click="prevQuestion"><i
                      class="el-icon-arrow-left mr-2"></i>{{ $t('testing.back-button') }}</a>
                  <el-button style="min-width: 130px;" :disabled="disabledNextBtn" @click="nextQuestion"
                              :loading="btnLoading"
                             class="btn btn-primary">{{ $t('testing.next-button') }}<i
                      class="el-icon-arrow-right ml-2"></i>
                  </el-button>
                </div>
              </div>
              <div class="text-center">
                <a class="btn btn-danger" @click="openModal">{{
                    $t('testing.finish-button')
                  }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-else/>
    <b-modal id="exit-modal" hide-footer hide-header>
      <div id="modal-wrapper">
        <div id="dialog">
          <button @click="$bvModal.hide('exit-modal')" type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <img class="modal-warning-img mb-3" src="/images/profile/modal-warning.svg">
          <h3 class="mb-0">{{modalTitle}}</h3>
          <p>{{ $t('testing.finish-modal-desc') }}</p>
          <div class="clearfix pt-3">
            <el-button @click="countMatches" class="btn btn-primary mx-2">
              {{ $t('testing.finish-modal-button') }}
            </el-button>
            <a @click="$bvModal.hide('exit-modal')"
               class="btn btn-outline-primary mx-2">{{ $t('testing.finish-modal-cancel') }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'katex/dist/katex.min.css';
import Loader from '../../components/Loader';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue';

Vue.use(VueViewer)
export default {
  name: "CriticalThinking",
  components: {
    Loader
  },
  data() {
    return {
      modalTitle: this.$t('testing.finish-modal-title'),
      keysTask1: [
        "благообразность",
        "великолепие",
        "гармония",
        "грация",
        "достоинство",
        "живописность",
        "загляденье",
        "изящность",
        "краса",
        "красота",
        "картинность",
        "миловидность",
        "нарядность",
        "прелесть",
        "пригожество",
        "привлекательность",
        "прекрасная",
        "эстетизм",
        "художественность"
      ],
      keysTask1KZ: [
        "кескінді",
        "асқан әдемілік",
        "үйлесімділік",
        "кербездік",
        "қадір-қасиет",
        "көз тартарлық",
        "жұқа өңді",
        "ажарлы",
        "сұлулық",
        "суреттей",
        "сүйкімді",
        "сән-салтанатты",
        "әйбат",
        "әсемдік",
        "тартымдылық",
        "келбетті",
        "эстетизм",
        "көркемдік"
      ],
      keysTask2: ['99', '123'],
      keysTask6: [
        "атрофия",
        "бездействие",
        "застой",
        "неподвижность",
        "обездвиженность",
        "остановка",
        "пауза",
        "пассивность",
        "перерыв",
        "покой",
        "приостановка",
        "простой",
        "статика",
        "стояние",
        "ступор",
        "торможение"
      ],
      keysTask6KZ: [
        "атрофия",
        "әрекетсіздік",
        "тоқырау",
        "қимылсыздық",
        "қозғалыссыз болу",
        "тоқтау",
        "кідірту",
        "пассивті",
        "үзіліс",
        "тыныштық",
        "тоқтата тұру",
        "қарапайым",
        "статикалық",
        "тұру",
        "мелшиіп тұрып қалу",
        "тежелу"
      ],
      keysTask17: [
        "пелоризация", "поляризация", "биоризация", "героизация", "бипиразол", "галеропия", "гипербола",
        "глицероза", "либерация", "лиризация", "облигация", "периалгия", "пироцелия", "побагрили", "погребица",
        "позабрили", "прибеглая", "репозиция", "робигалии", "аболиция", "агроцибе", "алопеция", "аоргезия",
        "апозиция", "базиоцер", "берлозга", "биолазер", "биполяра", "болгария", "бразилец", "бразилия", "зилаирец",
        "изобилие", "изогелия", "изоперла", "израилец", "иригация", "иризация", "либрация", "обрепция", "операция",
        "паргелии", "погаерил", "прецизия", "прибилец", "прилбица", "пробация", "пробаяли", "пролация", "алегрия",
        "алоизия", "аляриоз", "аплизия", "аргилия", "базиери", "барилия", "белоция", "берлиоз", "берлога", "биполяр",
        "газлиец", "галезия", "галиция", "гелозиа", "гизоция", "гиларии", "гиперия", "гирация", "глицера", "горации",
        "горлица", "елгарии", "заборец", "загорец", "зерцало", "зяблица", "изборец", "изогира", "изопаги", "иргизец",
        "лагеция", "легация", "либация", "либерия", "лигрица", "липарец", "липария", "лириопа", "лириопе", "лобария",
        "лябиоза", "облеция", "образец", "огилбия", "озагрел", "олеария", "паризии", "пелагия", "пелории", "пелория",
        "пергола", "перибол", "пецилия", "пилагор", "пилорез", "пиразол", "пирацеи", "пирогаз", "пиролиз", "плацебо",
        "погарец", "позиция", "поилица", "полиерг", "полицер", "полиции", "полиция", "порябил", "преголя", "пробела",
        "прялица", "регалии", "регалия", "религия", "репоция", "рибазол", "рибозил", "ризобии", "розалия", "целозия",
        "абелия", "абеляр", "аберия", "агирия", "азебия", "азигия", "азорец", "алберг", "алезия", "ализия", "алогия",
        "аперол", "апирия", "апогеи", "апозия", "апория", "аргези", "баглер", "багрец", "базиле", "балиец", "баоцзи",
        "баоцзя", "барели", "бариец", "барлия", "беглая", "безоар", "белиза", "белица", "бергия", "биарил", "биогаз",
        "благое", "блазия", "блезир", "блерио", "блеция", "блигия", "блицер", "блогер", "бойлер", "болгар", "бореал",
        "борзая", "бризол", "брозга", "бролга", "гарпия", "гезира", "гелиар", "гелиоз", "гераци", "герлиц", "гиалея",
        "гиалоз", "гиляби", "гиплер", "глазер", "глизер", "глобар", "глория", "гобиец", "голбец", "гоплия", "гориец",
        "горлец", "грабли", "грация", "гребло", "гребля", "греция", "гризли", "грозец", "грязца", "епилог", "ербоиз",
        "загреб", "заирец", "зилора", "иберия", "игарец", "иглица", "избела", "изолир", "илария", "иралия", "ицерия",
        "лабори", "леоция", "либера", "либеро", "либице", "лирица", "лопари", "лопяга", "обелия", "обилие", "олигия",
        "опилия", "оризия", "орилаг", "орлица", "пазило", "палеяз", "пароле", "пелиго", "пелиоз", "пеория", "перила",
        "пероба", "пигера", "пилица", "пиорея", "пирога", "плагио", "плегия", "плезир", "погреб", "поилец", "полгар",
        "полица", "поляра", "пореза", "порица", "порция", "прелог", "призба", "прилог", "прицел", "пробег", "пробел",
        "прогал", "прогиб", "пролаз", "прягла", "разбег", "разбел", "разгиб", "разлог", "реалия", "регбол", "репица",
        "рибоза", "цепола", "цибела", "циглер", "ципола", "ципрея", "абиоз", "азиец", "азобе", "алгия", "алиби", "алоги",
        "алцея", "апиол", "ареол", "ариги", "ариец", "аризо", "ароил", "арциз", "багер", "багия", "багор", "балор",
        "белая", "белги", "бели", "бери", "бига", "биза", "било", "биоз", "блио", "блиц", "блог", "боец", "боза",
        "бола", "бора", "борг", "боца", "брег", "брез", "бриг", "бриз", "брио", "гаер", "гази", "гале", "гаял",
        "гебр", "герб", "геро", "герц", "гиле", "гиря", "глаз", "глия", "гоби", "гола", "голе", "голец", "гора",
        "горб", "горе", "граб", "греи", "греп", "гриб", "грип", "гроб", "гроз", "егира", "егоза", "ерибо", "ерила",
        "забег", "забои", "забор", "загиб", "залог", "запил", "запор", "зария", "зацеп", "зебра", "зероа", "зигия",
        "зияра", "злоба", "зябер", "зябра", "ибаге", "ибога", "игапо", "игрец", "изгиб", "изгои", "излог", "илиец",
        "ирица", "лабео", "лабец", "лагер", "лазер", "лазея", "ларго", "ларец", "лацио", "лебия", "лепра", "либер",
        "либор", "либра", "лигия", "лизер", "липец", "липия", "липоз", "лобия", "лоция", "образ", "обрез", "олера",
        "опера", "опция", "оргия", "ориби", "орлец", "пазео", "палец", "палея", "палия", "парез", "парео", "парии",
        "пария", "паяло", "пелог", "перга", "перло", "пероз", "пилар", "пилея", "пилор", "пиляр", "пирия", "пирог",
        "пироз", "плица", "побег", "погиб", "позер", "полаз", "полба", "полиз", "полир", "полия", "порез", "проба",
        "проза", "рагия", "рацея", "рация", "регби", "регия", "резол", "релиз", "репли", "розга", "рябец", "цапля",
        "целая", "ципао", "ярило", "ярица", "абер", "абир", "абри", "агио", "агор", "азия", "азол", "азор", "алги",
        "алеи", "апир", "арил", "ария", "ацил", "бале", "баро", "бели", "бери", "бига", "биза", "било", "биоз", "блио",
        "блиц", "блог", "боец", "боза", "бола", "бора", "борг", "боца", "брег", "брез", "бриг", "бриз", "брио", "гаер",
        "гази", "гале", "гаял", "гебр", "герб", "геро", "герц", "гиле", "гиря", "глаз", "глия", "гоби", "гола", "голе",
        "голец", "гора", "горб", "горе", "граб", "греи", "греп", "гриб", "грип", "гроб", "гроз", "егира", "егоза",
        "ерибо", "ерила", "зало", "залп", "заря", "заяц", "зело", "зеро", "зипа", "зира", "злец", "зола", "зорб",
        "зоря", "иго", "иол", "ипо", "ияр", "лаг", "лаз", "лао", "лар", "лоа", "лоб", "лог", "лор", "ляп", "огар",
        "олеп", "опал", "опил", "орги", "орел", "ория", "оцеп", "паб", "паз", "пар", "пег", "пир", "пол", "раб",
        "раз", "реа", "рег", "рез", "рея", "риа", "рил", "роб", "рог", "рол", "роп", "цеп", "ярл", "аз", "ар",
        "ая", "га", "ил", "ре", "ял", "яр"
      ],
      keysTask17KZ: [
        "адыр", "алды", "анық", "ақ", "ақы", "ақыл", "ақын", "ар", "арын", "арынды",
        "арда", "арық", "арлы", "дақыл", "дақ", "дал", "дар", "дарын", "дарынды",
        "дық", "қадыр", "қан", "қанық", "қанды", "қал", "қалы", "қалды", "қар",
        "қары", "қарын", "қыдыр", "қыл", "қын", "қына", "қыр", "қыран", "қырын",
        "лақ", "лық", "нақ", "нар", "нарық", "нарын", "нық", "ық"
      ],
      crossword: [
        [{ value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: 'x', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '-', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '=', disabled: true }, { value: '21', black: false, placeholder: '', disabled: true }],
        [{ value: '', black: false, placeholder: 'x', disabled: true }, { value: '', black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: 'x', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: 'x', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }],
        [{ value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: 'x', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '-', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '=', disabled: true }, { value: '8', black: false, placeholder: '', disabled: true }],
        [{ value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }],
        [{ value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: 'x', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '-', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: null, black: false, placeholder: '=', disabled: true }, { value: '26', black: false, placeholder: '', disabled: true }],
        [{ value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: false, placeholder: '-', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }],
        [{ value: '9', black: false, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: '16', black: false, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: '11', black: false, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }, { value: null, black: true, placeholder: '', disabled: true }]
      ],
      rowsRedundantTable: [
        { column1: 'ЙЧКАА', column2: '', column3: 'Лишнее слово' },
        { column1: 'РАНОВО', column2: '', column3: '' },
        { column1: 'АКРИНТА', column2: '' },
        { column1: 'ИКЛАРИБ', column2: '' }
      ],
      rowsRedundantTableKZ: [
        { column1: 'АНУШРА', column2: '', column3: 'Қосымша сөз' },
        { column1: 'АРЛЫҚАМП', column2: '', column3: '' },
        { column1: 'ҚНЗАҚЫА', column2: '' },
        { column1: 'ҚДЫҚАҒЗЛА', column2: '' }
      ],
      rowsRedundantTable12: [
        {column1: 'ОС', column2: 'Общее слово'},
        {column1: 'ОБ', column2: ''},
        {column1: 'РОГА'},
        {column1: 'СТО',},
        {column1: 'КАР',},
        {column1: 'РО',},
      ],
      rowsRedundantTable12KZ: [
        {column1: 'ҚАЗАН', column2: 'Жалпы сөз'},
        {column1: 'ҚАН', column2: ''},
        {column1: 'ҚЫР'},
        {column1: 'САН',},
        {column1: 'СИП',},
        {column1: 'СЫЗ',},
      ],
      btnLoading: false,
      currentQuestion: 1,
      // answersCritical: [
      //   {question: 1, answer: 'краса', matchCount: ''},
      //   {question: 2, answer: ['99', '123'], matchCount: ''},
      //   {question: 3, answer: '3 вид', matchCount: ''},
      //   {question: 4, answer: ['*', '*', '*'], matchCount: ''},
      //   {question: 5, answer: '3,4,2,1', matchCount: ''},
      //   {question: 6, answer: 'пауза', matchCount: ''},
      //   {question: 7, answer: 'А1, В3, С6, D8', matchCount: ''},
      //   {question: 8, answer: '34,37,29', matchCount: ''},
      //   {question: 9, answer: 'картина', words: [], matchCount: ''},
      //   {question: 10, answer: '8', matchCount: ''},
      //   {
      //     question: 11, answer: [
      //       [{value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: 'x', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '=', disabled: true},
      //         {value: '21', black: false, placeholder: '', disabled: true}],
      //       [{value: '', black: false, placeholder: 'x', disabled: true},
      //         {value: '', black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: 'x', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: 'x', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true}],
      //       [{value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: 'x', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '=', disabled: true},
      //         {value: '8', black: false, placeholder: '', disabled: true}],
      //       [{value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true}],
      //       [{value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: 'x', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: '', black: false, placeholder: '?', disabled: false},
      //         {value: null, black: false, placeholder: '=', disabled: true},
      //         {value: '26', black: false, placeholder: '', disabled: true}],
      //       [{value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: false, placeholder: '-', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true}],
      //       [{value: '9', black: false, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: '16', black: false, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: '11', black: false, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true},
      //         {value: null, black: true, placeholder: '', disabled: true}]
      //     ], matchCount: '0'
      //   },
      //   {question: 12, answer: 'лоб', matchCount: ''},
      //   {question: 13, answer: '3', matchCount: ''},
      //   {question: 14, answer: '4 вид', matchCount: ''},
      //   {question: 15, answer: ['е, я', 'рефлексия'], matchCount: ''},
      //   {question: 16, answer: [
      //       [{ value: '9', black: false, placeholder: '', disabled: true }, { value: '8', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '7', black: false, placeholder: '', disabled: true }, { value: '8', black: false, placeholder: '', disabled: true }, { value: '4', black: false, placeholder: '', disabled: true }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '6', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }],
      //       [{ value: '', black: false, placeholder: '?', disabled: false }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '0', black: false, placeholder: '?', disabled: true }, { value: '4', black: false, placeholder: '', disabled: true }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '1', black: false, placeholder: '', disabled: true }, { value: '2', black: false, placeholder: '', disabled: true }, { value: '0', black: false, placeholder: '?', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '4', black: false, placeholder: '?', disabled: true }],
      //     ], matchCount: ''},
      //   {question: 17, answer: 'пелоризация', matchCount: ''},
      //   {question: 18, answer: 'АБГЗ', matchCount: ''},
      // ],
      answersCritical: [
        {question: 1, answer: '', matchCount: ''},
        {question: 2, answer: [], matchCount: ''},
        {question: 3, answer: '', matchCount: ''},
        {question: 4, answer: [], matchCount: ''},
        {question: 5, answer: '', matchCount: ''},
        {question: 6, answer: '', matchCount: ''},
        {question: 7, answer: '', matchCount: ''},
        {question: 8, answer: '', matchCount: ''},
        {question: 9, answer: '', words: [], matchCount: ''},
        {question: 10, answer: [], steps: '', matchCount: ''},
        {
          question: 11, answer: [
            [{value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: 'x', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '-', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '=', disabled: true},
              {value: '21', black: false, placeholder: '', disabled: true}],
            [{value: '', black: false, placeholder: 'x', disabled: true},
              {value: '', black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: 'x', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: 'x', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true}],
            [{value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: 'x', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '-', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '=', disabled: true},
              {value: '8', black: false, placeholder: '', disabled: true}],
            [{value: null, black: false, placeholder: '-', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: '-', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: '-', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true}],
            [{value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: 'x', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '-', disabled: true},
              {value: '', black: false, placeholder: '?', disabled: false},
              {value: null, black: false, placeholder: '=', disabled: true},
              {value: '26', black: false, placeholder: '', disabled: true}],
            [{value: null, black: false, placeholder: '=', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: '=', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: false, placeholder: '=', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true}],
            [{value: '9', black: false, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: '16', black: false, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: '11', black: false, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true},
              {value: null, black: true, placeholder: '', disabled: true}]
          ], matchCount: '0'
        },
        {question: 12, answer: '', matchCount: ''},
        {question: 13, answer: '', matchCount: ''},
        {question: 14, answer: '', matchCount: ''},
        {question: 15, answer: [], matchCount: ''},
        {question: 16, answer: [
            [{ value: '9', black: false, placeholder: '', disabled: true }, { value: '8', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '7', black: false, placeholder: '', disabled: true }, { value: '8', black: false, placeholder: '', disabled: true }, { value: '4', black: false, placeholder: '', disabled: true }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '6', black: false, placeholder: '', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }],
            [{ value: '', black: false, placeholder: '?', disabled: false }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '0', black: false, placeholder: '?', disabled: true }, { value: '4', black: false, placeholder: '', disabled: true }, { value: '5', black: false, placeholder: '', disabled: true }, { value: '1', black: false, placeholder: '', disabled: true }, { value: '2', black: false, placeholder: '', disabled: true }, { value: '0', black: false, placeholder: '?', disabled: true }, { value: '', black: false, placeholder: '?', disabled: false }, { value: '4', black: false, placeholder: '?', disabled: true }],
          ], matchCount: ''},
        {question: 17, answer: '', matchCount: ''},
        {question: 18, answer: '', matchCount: ''},
      ],
      question_answers: ['3,4,2,1', '4,3,2,1', '4,2,3,1', '4,3,1,2'],
      question_answers3: ['1 вид', '2 вид', '3 вид', '4 вид'],
      question_answers7: ['A8, B3, C5, D7', 'A4, B7, C1, D3', 'А1, В3, С6, D8', 'A2, B5, C7, D1'],
      question_answers8: ['34,37,29', '25,46,29', '13,46,29,25', '37,22,29'],
      question_answers14: ['1 вид', '2 вид', '3 вид', '4 вид'],
      question_answers18: ['АБГЗ', 'АБГВ', 'ВБГЗ', 'ВДЕЖ'],
      sumResults: '',
      typeIntelligence: [],
      blockButton: false,
      loading: false,
      countdown: 0,
      timerInterval: null,
      quiz: {
        proctoring: false
      },
      orderQuestionsCT: [],
    }
  },
  methods: {
    determineLevel(count, lang) {
      if (count >= 30) {
        // return "высокий";
        return lang == "ru" ? "высокий" : "жоғары деңгей";
      } else if (count >= 21) {
        return lang == "ru" ? "выше среднего" : "орташадан жоғары";
      } else if (count >= 10) {
        return lang == "ru" ? "средний" : "орташа деңгей";
      } else {
        return lang == "ru" ? "в зоне ближайшего развития" : "жақын даму аймағында";
      }
    },
    async countMatches() {

      // первое задание
      const inputWords = this.answersCritical[0].answer.split(',').map(word => word && word.trim().toLowerCase());
      let totalScore = 0;

      if (this.$i18n.locale == 'ru') {
        for (const word of inputWords) {
          if (this.keysTask1.includes(word)) {
            totalScore += totalScore < 2 ? 1 : 0.5;
          }
        }
      } else for (const word of inputWords) {
        if (this.keysTask1KZ.includes(word)) {
          totalScore += totalScore < 2 ? 1 : 0.5;
        }
      }

      this.answersCritical[0].matchCount = totalScore;
      // второе задание

      if ((this.answersCritical[1].answer[0] && this.answersCritical[1].answer[0].trim() == this.keysTask2[0])
          && (this.answersCritical[1].answer[1] && this.answersCritical[1].answer[1].trim() == this.keysTask2[1])) {
        this.answersCritical[1].matchCount = 2
      } else {
        this.answersCritical[1].matchCount = 0
      }

      // третье задание

      if (this.answersCritical[2].answer.trim() == '1 вид') {
        this.answersCritical[2].matchCount = 2
      } else {
        this.answersCritical[2].matchCount = 0
      }

      // четвертое задание

      if (this.answersCritical[3].answer[0] == '*' && this.answersCritical[3].answer[1] == '+' && this.answersCritical[3].answer[2] == '*') {
        this.answersCritical[3].matchCount = 2
      } else {
        this.answersCritical[3].matchCount = 0
      }

      // пятое задание

      if (this.answersCritical[4].answer == '3,4,2,1' ) {
        this.answersCritical[4].matchCount = 2
      } else {
        this.answersCritical[4].matchCount = 0
      }

      // шестое задание

      const inputWords6 = this.answersCritical[5].answer.split(',').map(word => word.trim().toLowerCase());
      let totalScore6 = 0;

      if (this.$i18n.locale == 'ru') {
        for (const word of inputWords6) {
          if (this.keysTask6.includes(word)) {
            totalScore6 += totalScore6 < 2 ? 1 : 0.5;
          }
        }
      } else {
        for (const word of inputWords6) {
          if (this.keysTask6KZ.includes(word)) {
            totalScore6 += totalScore6 < 2 ? 1 : 0.5;
          }
        }
      }

      this.answersCritical[5].matchCount = totalScore6;

      // седьмое задание

      if (this.answersCritical[6].answer == 'А1, В3, С6, D8') {
        this.answersCritical[6].matchCount = 2
      } else {
        this.answersCritical[6].matchCount = 0
      }

      // восьмое задание

      if (this.answersCritical[7].answer == '25,46,29') {
        this.answersCritical[7].matchCount = 2
      } else {
        this.answersCritical[7].matchCount = 0
      }

      // девятое задание

      if (this.$i18n.locale == 'ru') {
        if (this.answersCritical[8].answer.toLowerCase() == 'картина') {
          this.answersCritical[8].matchCount = 2
        } else {
          this.answersCritical[8].matchCount = 0
        }
      } else {
        if (this.answersCritical[8].answer.toLowerCase() == 'қызанақ') {
          this.answersCritical[8].matchCount = 2
        } else {
          this.answersCritical[8].matchCount = 0
        }
      }

      // десятое задание

      if (this.answersCritical[9].answer.join('') === [2, 4, 2, 4, 3, 2, 1, 3, 1, 2].join('')) {
        this.answersCritical[9].matchCount = 2
      } else {
        this.answersCritical[9].matchCount = 0
      }

      // одиннадцатое задание
      const answer1 = this.answersCritical[10].answer[0][0].value
      const answer2 = this.answersCritical[10].answer[0][2].value
      const answer3 = this.answersCritical[10].answer[0][4].value
      const answer4 = this.answersCritical[10].answer[2][0].value
      const answer5 = this.answersCritical[10].answer[2][2].value
      const answer6 = this.answersCritical[10].answer[2][4].value
      const answer7 = this.answersCritical[10].answer[4][0].value
      const answer8 = this.answersCritical[10].answer[4][2].value
      const answer9 = this.answersCritical[10].answer[4][4].value

      if (answer1 == 6 && answer2 == 4 && answer3 == 3 &&
          answer4 == 3 && answer5 == 5 && answer6 == 7 &&
          answer7 == 9 && answer8 == 4 && answer9 == 10) {
        this.answersCritical[10].matchCount = 2;
      } else {
        this.answersCritical[10].matchCount = 0;
      }

      // двенадцатое задание

      if (this.$i18n.locale == 'ru') {
        if (this.answersCritical[11].answer.toLowerCase() == 'лик') {
          this.answersCritical[11].matchCount = 2
        } else {
          this.answersCritical[11].matchCount = 0
        }
      } else {
        if (this.answersCritical[11].answer.toLowerCase() == 'ат') {
          this.answersCritical[11].matchCount = 2
        } else {
          this.answersCritical[11].matchCount = 0
        }
      }


      // тринадцатое задание

      if (this.answersCritical[12].answer.toLowerCase() == 3 ) {
        this.answersCritical[12].matchCount = 2
      } else {
        this.answersCritical[12].matchCount = 0
      }

      // четырнадцатое задание

      if (this.answersCritical[13].answer.trim() == '2 вид') {
        this.answersCritical[13].matchCount = 2
      } else {
        this.answersCritical[13].matchCount = 0
      }

      // пятнадцатое задание

      if (this.$i18n.locale == 'ru') {
        if (((this.answersCritical[14].answer[0] && this.checkString(this.answersCritical[14].answer[0]) == 'ея')
            || (this.answersCritical[14].answer[0] && this.checkString(this.answersCritical[14].answer[0]) == 'яе')) && this.answersCritical[14].answer[1].trim().toLocaleLowerCase() == 'рефлексия') {
          this.answersCritical[14].matchCount = 2
        } else {
          this.answersCritical[14].matchCount = 0
        }
      } else {
        if ( (this.answersCritical[14].answer[0] && this.checkString(this.answersCritical[14].answer[0]) == 'б') && (this.answersCritical[14].answer[1] && this.answersCritical[14].answer[1].trim().toLocaleLowerCase() == 'бауырсақ')) {
          this.answersCritical[14].matchCount = 2
        } else {
          this.answersCritical[14].matchCount = 0
        }
      }

      // шестнадцатое задание
      const answer1_16 = this.answersCritical[15].answer[0][2].value
      const answer2_16 = this.answersCritical[15].answer[0][7].value
      const answer3_16 = this.answersCritical[15].answer[0][9].value
      const answer4_16 = this.answersCritical[15].answer[1][0].value
      const answer5_16 = this.answersCritical[15].answer[1][8].value

      if (answer1_16 == 3 && answer2_16 == 3 && answer3_16 == 7 &&
          answer4_16 == 3 && answer5_16 == 3 ) {
        this.answersCritical[15].matchCount = 2;
      } else {
        this.answersCritical[15].matchCount = 0;
      }

      // семнадцатое задание
      const inputWords17 = this.answersCritical[16].answer.split(',').map(word => word.trim().toLowerCase());
      let totalScore17 = 0;

      if (this.$i18n.locale == 'ru') {
        for (const word of inputWords17) {
          if (this.keysTask17.includes(word)) {
            totalScore17 += totalScore17 < 2 ? 1 : 0.5;
          }
        }
        this.answersCritical[16].matchCount = totalScore17;
      } else {
        for (const word of inputWords17) {
          if (this.keysTask17KZ.includes(word)) {
            totalScore17 += totalScore17 < 2 ? 1 : 0.5;
          }
        }
        this.answersCritical[16].matchCount = totalScore17;
      }


      // восемнадцатое задание

      if (this.answersCritical[17].answer == 'АБГЗ' ) {
        this.answersCritical[17].matchCount = 2
      } else {
        this.answersCritical[17].matchCount = 0
      }

      this.sumResults = this.answersCritical.reduce((acc, item) => {
        return acc + item.matchCount
      }, 0)

      this.typeIntelligence[0] = {title_ru : "числовой", title_kz: "сандық", result:
            this.answersCritical[1].matchCount +
            this.answersCritical[3].matchCount +
            this.answersCritical[7].matchCount +
            this.answersCritical[10].matchCount +
            this.answersCritical[12].matchCount +
            this.answersCritical[15].matchCount
      }
      this.typeIntelligence[1] = {title_ru : "вербальный", title_kz: "сөздік", result:
            this.answersCritical[0].matchCount +
            this.answersCritical[5].matchCount +
            this.answersCritical[8].matchCount +
            this.answersCritical[11].matchCount +
            this.answersCritical[14].matchCount +
            this.answersCritical[16].matchCount}
      this.typeIntelligence[2] = {title_ru : "визуально-пространственный", title_kz: "көрнекі-кеңістіктік", result:
            this.answersCritical[2].matchCount +
            this.answersCritical[4].matchCount +
            this.answersCritical[6].matchCount +
            this.answersCritical[9].matchCount +
            this.answersCritical[13].matchCount +
            this.answersCritical[17].matchCount}

      let params = JSON.parse(localStorage.getItem('quiz-params'))

      let textsInterpretation = {};

      textsInterpretation.ru = `Общий интеллект и уровень критического мышления - ${this.determineLevel(this.sumResults, "ru")}. Преобладающий тип: ${this.typeIntelligence.sort((a, b) => b.result - a.result)[0].title_ru} `

      textsInterpretation.kz = `Жалпы интеллект және сыни ойлау деңгейі - ${this.determineLevel(this.sumResults, "kz")}. Басым түрі: ${this.typeIntelligence.sort((a, b) => b.result - a.result)[0].title_kz} `


      if (this.sumResults >= 21) {
        // textsInterpretation = textsInterpretation + this.$t('critical-thinking.recommendations-high')
        textsInterpretation.ru = textsInterpretation.ru + "<br> Твои результаты теста достаточно высокие! Теперь тебе рекомендуется пройти дополнительную диагностику в офлайн формате. Для этого нужно записаться к психологу на определенное время на сайте службы Кабилет в региональный центр «Дарын»."
        textsInterpretation.kz = textsInterpretation.kz + "<br> Сенің тест нәтижелерің жеткілікті дәрежеде жоғары! Енді саған офлайн форматта қосымша диагностикадан өту ұсынылады. Ол үшін Қабілет қызметінің сайтында белгілі бір уақытқа тіркелу қажет."
      } else {
        textsInterpretation.ru = textsInterpretation.ru + "<br> 1. Тебе необходимо тренировать отдельные элементы критического мышления, а именно:<br> - задавать вопросы;<br> - находить скрытые детали в любой информации; <br> - кратко формулировать высказывания;<br> - видеть ситуацию разными способами (сравнивать спорные аргументы, противоположные версии развития событий);<br> - прогнозировать развитие событий;<br> - находить новые пути решения проблемы;<br> - отличать оценку ситуации от оценки личности (при этом обходите стереотипы, воспринимайте не только первые впечатления, но и последующие идеи)<br> - умения слушать себя и прислушиваться к интуиции.<br> 2. Тебе необходимо также развивать эмоциональный и социальный интеллект, чтобы отличать свои решения, основанные на эмоциях или на общественном влиянии от решений, основанных на интуиции и логике.<br> 3. При слабом визуально-пространственном интеллекте следует использовать различные приемы его развития, например:<br> - использовать прием мысленного измерения расстояний до разных предметов.<br> - Потренируйтесь в определении количества шагов до того или иного места, которое видите издалека на улице.<br> - Вспомните куда вы ходите пешком и придумайте маршрут длиннее, короче.<br> - Если вам интересно рисовать, понаблюдайте, как получаются на рисунке тени, за счет чего в цвете, размере создаются фигуры с эффектом 3D.<br> - Научитесь мысленному представлению, возьмите в воображении любую фигуру и повращайте её, а затем сделайте то же самое в реальности и сравните результаты.<br>  4. Тебе необходимо развивать математический интеллект, который основан на способности абстрактно мыслить. Это важная часть логического мышления. Математику не зря называют царицей наук. Возможно ты и не выберешь профессию, связанную с математикой, но развивать некоторые навыки полезно для тренировки гибкости ума, критического анализа ситуаций и быстрого принятия решений в жизни.<br>  Для этого полезно следующее:<br> - решать больше различных задач по математике и логике;<br> - решать различные ребусы, головоломки,судоку и так далее. Посмотрите, что вам интереснее;<br> - найдите себе единомышленников. Иногда вместе интереснее. Решайте задачки вместе с кем-то, можно создать в команде дух сотрудничества или соревнований. Юмор также способствует вдохновению.<br> - придумывайте сами, как задачки сделать смешными, игровыми. Игра – интересный способ учиться новому"
        textsInterpretation.kz = textsInterpretation.kz + "<br> Сын тұрғысынан ойлаудың жеке элементтерін жаттықтыру керек, атап айтқанда:<br> - сұрақтар қою;<br> - кез-келген ақпараттан жасырын мәліметтерді табу;<br> - пікірлерді қысқаша тұжырымдау;<br> - жағдайды әртүрлі тәсілдермен қарастыру (даулы дәлелдерді, оқиғалардың қарама-қарсы нұсқаларын салыстыру);<br> - оқиғалардың дамуын болжау;<br> - мәселені шешудің жаңа жолдарын табу;<br> - жағдайды бағалауды жеке тұлғаны бағалаудан ажырата білу (стереотиптерді айналып өтіп, алғашқы әсерлерді ғана емес, сонымен қатар кейінгі идеяларды да қабылдаңыз);<br> - өзіңді тыңдай білу және интуицияңды тыңдай білу.<br>  Сіз, сондай-ақ, эмоцияларға немесе әлеуметтік әсерге негізделген шешімдеріңізді интуиция мен логикаға негізделген шешімдерден ажырату үшін эмоционалды және әлеуметтік интеллектіні дамытуыңыз керек. <br> Визуалды-кеңістіктік интеллект әлсіз болған кезде оны дамытудың әртүрлі әдістерін қолдану керек, мысалы:<br>  - Әртүрлі заттарға дейінгі қашықтықты ойша өлшеу әдісін қолданыңыз.<br> - Көшеде алыстан көрген сол жердегі немесе басқа жерге дейінгі қадамдар санын анықтауға машықтаныңыз.<br> - Жаяу қайда бара жатқаныңызды есіңізде сақтаңыз және маршрутты ұзағырақ, қысқа етіп жасаңыз.<br> - Егер сіз сурет салуға қызығушылық танытсаңыз, көлеңкелердің суретте қалай пайда болатынын, соның арқасында 3D эффектісі бар фигуралар түспен, өлшеммен жасалатынын байқаңыз.<br> - Ойша бейнелеуді үйреніңіз, кез-келген фигураны елестетіп, оны айналдырыңыз, содан кейін шындықта дәл осылай жасаңыз және нәтижелерді салыстырыңыз. <br> Сіз абстрактілі ойлау қабілетіне негізделген математикалық интеллектіні дамытуыңыз керек. Бұл логикалық ойлаудың маңызды бөлігі. Математика ғылымдардың патшайымы деп бекер айтылмаған. Сіз математикамен байланысты мамандықты таңдамауыңыз мүмкін, бірақ кейбір дағдыларды дамыту ақыл-ойдың икемділігін үйрету, жағдайларды сыни тұрғыдан талдау және өмірде тез шешім қабылдау үшін пайдалы болмақ. <br> Ол үшін мыналар пайдалы: <br> - математика және логика бойынша әртүрлі есептерді шешу;<br> - әр түрлі жұмбақтарды, басқатырғыштарды, судокуды және т.б. шешіңіз. <br> - сізге не қызықты екенін қараңыз;<br> - өзіңізге пікірлес адамдарды табыңыз. Кейде бірге қызықты болады. Тапсырмаларды біреумен бірге шешіңіз, сіз командада ынтымақтастық рухын немесе бәсекелестікті құра аласыз. Әзіл де адамды шабыттандырады.<br> - тапсырмаларды қалай күлкілі, ойынға айналдыру керектігін өзіңіз ойлап табыңыз. Ойын-жаңа нәрселерді үйренудің қызықты тәсілі."
      }


      const criticalThinkingSendAnswers = [
        this.answersCritical, {sum: this.sumResults}, {typeIntelligence: this.typeIntelligence.sort((a, b) => b.result - a.result)}, {textsInterpretation}
      ]

      params.answer_id = {...params.answer_id, criticalThinkingSendAnswers}
      localStorage.setItem('quiz-params', JSON.stringify(params))
      const quizToken = localStorage.getItem('quiz-token')
      const response = await this.$http.post(API_ROOT + '/api/user-answer/' + quizToken, params)

      if (response.body.status == 'success') {

        Vue.toastr({
          message: this.$t('successful'),
          description: this.$t('saved-successfully'),
          type: 'success'
        })
      } else {
        Vue.toastr({
          message: this.$t('error-title'),
          description: this.$t('error-saving'),
          type: 'error'
        })
      }

      console.log('params', params)
      console.log('this.answersCritical', this.answersCritical)

      setTimeout(() => {
        this.$router.push({ path: '/about-new/creativity' })
      }, 1500)
    },
    isChecked(key) {
      const keyValue = key - 1
      switch (key) {
        case 1:
        case 3:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 12:
        case 13:
        case 14:
        case 17:
        case 18:
          return this.answersCritical[keyValue].answer !== ''

        case 2:
        case 15:
          return this.answersCritical[keyValue].answer.length == 2

        case 4:
          return this.answersCritical[keyValue].answer.length == 3
        case 10:
          return this.answersCritical[keyValue].answer.length > 0

        case 16: {
          const answer1 = this.answersCritical[15].answer[0][2].value
          const answer2 = this.answersCritical[15].answer[0][7].value
          const answer3 = this.answersCritical[15].answer[0][9].value
          const answer4 = this.answersCritical[15].answer[1][0].value
          const answer5 = this.answersCritical[15].answer[1][8].value
          let answersArr = [answer1, answer2, answer3, answer4, answer5,]
          answersArr = answersArr.filter(item => item != '')
          return answersArr.length == 5
        }

        case 11: {
          const answer1 = this.answersCritical[10].answer[0][0].value
          const answer2 = this.answersCritical[10].answer[0][2].value
          const answer3 = this.answersCritical[10].answer[0][4].value
          const answer4 = this.answersCritical[10].answer[2][0].value
          const answer5 = this.answersCritical[10].answer[2][2].value
          const answer6 = this.answersCritical[10].answer[2][4].value
          const answer7 = this.answersCritical[10].answer[4][0].value
          const answer8 = this.answersCritical[10].answer[4][2].value
          const answer9 = this.answersCritical[10].answer[4][4].value
          let answersArr = [answer1, answer2, answer3, answer4, answer5, answer6, answer7, answer8, answer9]
          answersArr = answersArr.filter(item => item != '')
          return answersArr.length == 9
        }
      }


    },
    show() {
      // console.log('answersCritical', this.answersCritical)
      this.countMatches()
    },
    checkString(str) {
      let cleanStr = str.replace(/[^a-zA-Zа-яА-Я\s]/g, '');
      cleanStr = cleanStr.replace(/\s/g, '');
      let newStr = cleanStr.slice(0, 2).toLocaleLowerCase();
      return newStr
    },
    nextQuestion() {
      const index = this.orderQuestionsCT.indexOf(this.currentQuestion)
      this.currentQuestion = this.orderQuestionsCT[index + 1]
    },
    prevQuestion() {
      const index = this.orderQuestionsCT.indexOf(this.currentQuestion)
      if (index == 0) {
        this.currentQuestion = this.orderQuestionsCT[0]
      } else {
        this.currentQuestion = this.orderQuestionsCT[index - 1]
      }
    },
    goTo(key) {
      this.currentQuestion = key
      // localStorage.setItem('answersCritical', JSON.stringify(this.answersCritical))
    },
    openModal() {
      this.$bvModal.show('exit-modal');
    },
    startTimer(duration) {
      let timer = duration, minutes, seconds;
      this.timerInterval = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.countdown = minutes + ":" + seconds;

        let savedTimer = (parseInt(minutes) * 60) + parseInt(seconds);
        localStorage.setItem('timerCriticalThinking', savedTimer);

        if (--timer < 0) {
          this.countMatches()
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
  },
  computed: {
    disabledNextBtn() {
      const index = this.orderQuestionsCT.indexOf(this.currentQuestion)
      return index == 17
    },
    // crosswordAnswers() {
    //   const answer1 = this.crossword[0][0].value
    //   const answer2 = this.crossword[0][2].value
    //   const answer3 = this.crossword[0][4].value
    //   const answer4 = this.crossword[2][0].value
    //   const answer5 = this.crossword[2][2].value
    //   const answer6 = this.crossword[2][4].value
    //   const answer7 = this.crossword[4][0].value
    //   const answer8 = this.crossword[4][2].value
    //   const answer9 = this.crossword[4][4].value
    //   let answersArr = [answer1, answer2, answer3, answer4, answer5, answer6, answer7, answer8, answer9]
    //   answersArr = answersArr.filter(item => item != '')
    //   return answersArr
    // }
  },
  mounted() {
    if (localStorage.getItem('timerCriticalThinking')) {
      this.startTimer(localStorage.getItem('timerCriticalThinking'))
    } else {
      this.startTimer(1200)
    }
    if (localStorage.getItem('answersCritical')) {
      this.answersCritical = JSON.parse(localStorage.getItem('answersCritical'))
    }

    this.orderQuestionsCT = this.shuffleArray([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]);

    let test_lang = localStorage.getItem('test_lang')

    this.currentQuestion = this.orderQuestionsCT[0]

    if (test_lang){
      this.$i18n.locale = test_lang;
    }
  },
  beforeCreate() {
    if (localStorage.getItem('quiz')) {
      let quiz = localStorage.getItem('quiz');
      quiz = JSON.parse(quiz);
      if (localStorage.getItem('identification')) {
        let identification = localStorage.getItem('identification');
        identification = JSON.parse(identification);
        if (quiz.proctoring && !identification) {
          window.location.href = '/identification';
        }
      }
    } else {
      this.$router.push({name: 'not-found'})
    }
  },

  beforeDestroy() {
    window.removeEventListener(this.windowUnloadType, this.beforeUnloadRequest)
  },
}
</script>

<style>

.answer-item {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 20px;
  line-height: 23px;
}

.custom-select-exercises {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  width: fit-content;
  outline: none;
}

.redundant-word-table td {
  min-width: 150px;
}

.crossword {
  display: flex;
  flex-direction: column;
}

.crossword-safe {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 183px;
  left: 266px;
  background: white;
}

.crossword-row {
  display: flex;
}

.crossword-cell {
  border: 1px solid #ccc;
  width: 60px;
  height: 60px;
}

.crossword-cell-safe {
  border: 1px solid #ccc;
  width: 30px;
  height: 56px;
}

.black-cell {
  background-color: black;
}

.answer-cell {
  border: 2px solid red;
}

.answer-cell input {
  outline: none;
}

.answer-cell input::placeholder {
  color: black;
  font-size: 24px;
}

.crossword-cell input {
  width: 100%;
  height: 100%;
  text-transform: uppercase;
  text-align: center;
  font-size: 24px;
}

.crossword-cell-safe input {
  width: 100%;
  height: 100%;
  text-transform: uppercase;
  text-align: center;
}

.question-content-title {
  margin-bottom: 20px;
}

.flower_letter {
  outline: none;
  position: absolute;
  width: 67px;
  font-size: 25px;
}

.flower_word {
  outline: none;
  position: absolute;
  width: 176px;
  font-size: 30px;
}




.quiz-image-wrapper {
  grid-template-columns: repeat(3, 1fr);
  display: grid;
  gap: 25px 20px;
}

.quiz-image {
  display: block;
  width: 100%;
  height: auto;
  margin: 1rem auto;
}

.disabled_svg {
  stroke: green !important;
  fill: green !important;
  cursor: not-allowed !important;
}

.hover-svg:hover {
  cursor: pointer;
  stroke: blue;
  transition-duration: 0.5s;
}


.hover-svg-fill:hover {
  cursor: pointer !important;
  stroke: blue;
  fill: blue;
  transition-duration: 0.5s;
}

.active-svg-fill {
  stroke: lime;
  fill: lime;
}

.active-svg {
  stroke: lime;
}

.viewer-title {
  display: none;
}

.viewer-next {
  display: none;
}

.viewer-prev {
  display: none;
}

.viewer-navbar {
  display: none;
}

.prompt-border {
  margin-top: 22px;
  margin-bottom: 22px;
  padding: 14px;
  background: #FFFFFF;
  border: 1px solid #DFE0EB;
  box-sizing: border-box;
  border-radius: 5px;
  font-family: 'Roboto Condensed';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 158.5%;
  color: #303030;
}

.custom-answer-select {
  padding: 10px 35px 10px 15px;
  border: 1px solid #dfdfdf;
  appearance: none;
  border-radius: 6px;
  background-image: url('/images/down-filled-triangular-arrow.svg');
  background-size: 12px 12px;
  background-repeat: no-repeat;
  background-position: 90% 50%;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  text-decoration: none;
}

p {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-block;
}

.question-content p {
  font-size: 20px;
}

.el-radio__label p,
.el-checkbox__label p {
  margin: 0;
  font-size: 18px;
}

.el-radio__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 14px;
  white-space: normal;
}

.el-checkbox__input,
.el-radio__input {
  display: block;
  float: left;
  margin: 3px 0 0;
}

.el-radio.is-bordered {
  padding-bottom: 12px;
}

.row {
  direction: initial;
}

.el-checkbox.is-bordered,
.el-radio.is-bordered {
  max-height: fit-content;
  height: initial;
  min-height: inherit;
  border: transparent;
}

@supports (-webkit-touch-callout: none) {
  .el-checkbox.is-bordered,
  .el-radio.is-bordered {
    max-height: fit-content;
    min-height: 40px;
  }

  .row {
    display: initial;
  }
}

.el-checkbox.is-checked,
.el-radio.is-checked {
  background: #fff;
  border: transparent;
}

.mobile-butons {
  display: none !important;
}

@media screen and (max-width: 991px) {
  .quiz-image-wrapper {
    display: block;
  }

  .order-2-mob-help {
    order: 1;
  }

  .order-mobile {
    order: 2 !important;
  }

  .mobile-butons {
    display: block !important;
  }

  .question-content {
    border: 1px solid red;
    overflow-x: auto;
  }
}
</style>
